import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { connectMediaStore, useMMSelector } from './withOwnReduxStore';
import { getAllowedDeviationTypes, getAllowedDeviationResourceTypes, getAllowGifs, getAllowPremium, getAllowMature, getIgnoreDeviationIds, getMinDeviationWidth, getMinDeviationHeight, getAllowInTierContent } from '../selectors';
const mapStateToProps = (state)=>({
        allowedDeviationTypes: getAllowedDeviationTypes(state),
        allowedDeviationResourceTypes: getAllowedDeviationResourceTypes(state),
        allowGifs: getAllowGifs(state),
        allowPremium: getAllowPremium(state),
        allowInTierContent: getAllowInTierContent(state),
        allowMature: getAllowMature(state),
        ignoreDeviationIds: getIgnoreDeviationIds(state),
        minDeviationWidth: getMinDeviationWidth(state),
        minDeviationHeight: getMinDeviationHeight(state)
    });
export const useFilterProps = ()=>_object_spread({}, useMMSelector(mapStateToProps));
export default connectMediaStore(mapStateToProps);
